import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Constants } from 'galarm-config'
import { Box, List, Text } from 'grommet'
import { Checkmark } from 'grommet-icons'
import GroupAvatar from './GroupAvatar'
import objGet from 'lodash/get'
import SearchBar from './SearchBar'
import { Selectors } from 'galarm-shared'
import { SecondaryText } from 'web-components'
import Separator from './Separator'

const { sortedGroupListSelectorForAlarmParticipant, recentGroupsSelector } =
  Selectors

const GroupSummary = item => {
  return (
    <Box direction="row" justify="between" align="center">
      <Box direction="row" align="center" gap="small">
        <GroupAvatar
          url={objGet(item, 'images.avatarThumbnailUrl', undefined)}
          name={item.name}
        />
        <Text>{item.name}</Text>
      </Box>
      {item.selected && <Checkmark />}
    </Box>
  )
}

const SelectGroup = ({ selectedGroup, onSelectGroup }) => {
  const [searchText, setSearchText] = useState('')

  const onClickGroup = ({ item }) => {
    onSelectGroup(item)
  }

  const groups = useSelector(state =>
    sortedGroupListSelectorForAlarmParticipant(state)
  )
  const recentGroups = useSelector(state => recentGroupsSelector(state))

  if (groups.length === 0) {
    return (
      <Box flex justify="center" align="center">
        <Text>{I18n.t('noGroupsCreated')}</Text>
      </Box>
    )
  }

  const showRecentGroups = recentGroups.length > 0 && !searchText

  let groupsData = []
  let recentGroupsData = []

  let filteredGroups = searchText
    ? groups.filter(group =>
        group.name.toLowerCase().includes(searchText.toLowerCase())
      )
    : groups

  // Prepare recently used groups data
  if (showRecentGroups) {
    recentGroups.forEach(group => {
      if (selectedGroup !== null && selectedGroup.id === group.id) {
        recentGroupsData.push({
          ...selectedGroup,
          selected: true,
          participantType: Constants.ParticipantTypes.GROUP
        })
      } else {
        recentGroupsData.push({
          ...group,
          selected: false,
          participantType: Constants.ParticipantTypes.GROUP
        })
      }
    })
  }

  filteredGroups.forEach(group => {
    if (selectedGroup !== null && selectedGroup.id === group.id) {
      groupsData.push({
        ...selectedGroup,
        selected: true,
        participantType: Constants.ParticipantTypes.GROUP
      })
    } else {
      groupsData.push({
        ...group,
        selected: false,
        participantType: Constants.ParticipantTypes.GROUP
      })
    }
  })

  const onChangeText = newText => {
    setSearchText(newText)
  }

  return (
    <Box overflow="auto">
      <SearchBar onChangeText={onChangeText} searchText={searchText} />
      {showRecentGroups && (
        <Box flex={{ shrink: 0 }}>
          <Box pad={{ horizontal: 'small', vertical: 'xsmall' }}>
            <SecondaryText>{I18n.t('recentlyUsed')}</SecondaryText>
          </Box>
          <List
            data={recentGroupsData}
            onClickItem={onClickGroup}
            // eslint-disable-next-line react/no-children-prop
            children={GroupSummary}
          />
          <Separator />
        </Box>
      )}
      {filteredGroups && filteredGroups.length === 0 && (
        <Box pad="medium" flex justify="center" align="center">
          <Text color="textColor">
            {I18n.t('noSearchResultsFound', { type: 'groups' })}
          </Text>
        </Box>
      )}
      <Box flex={{ shrink: 0 }}>
        <List
          data={groupsData}
          onClickItem={onClickGroup}
          // eslint-disable-next-line react/no-children-prop
          children={GroupSummary}
        />
      </Box>
    </Box>
  )
}

export default SelectGroup
